import React from 'react'
import { Tooltip } from '@material-ui/core'
import Chip from '../StyledChip'
import { IChip } from '../StyledChip/StyledChip'

interface ITooltipedChip extends IChip {
  value?: string
  tooltipTitle: string
  disableHover?: boolean
}

export const TooltipedChip = ({
  value,
  tooltipTitle,
  label,
  disableHover = false,
  ...rest
}: ITooltipedChip) => (
  <Tooltip
    disableHoverListener={disableHover}
    title={`${value ? `${value} - ` : ''}${
      tooltipTitle === '' ? '' : tooltipTitle || label
    }`}
  >
    <Chip label={label} key={value} {...rest} />
  </Tooltip>
)
